import getAccountProperties from './getAccountProperties'

export default function hasActiveAnnualMembership() {
  const { activeAnnualPass } = getAccountProperties()

  return !!activeAnnualPass
}
